'use client';

import { useMemo } from 'react';
import type { AnimationType } from './animation-drag-data';
import type { ItemAnimation } from '../../../../items/animation/animation-item-type';
import { calculateAnimationsStyle } from '../../../../items/animation/calculate-animation';
import { toPreviewAnimation } from '../../../../items/animation/preview-animation';

interface AnimationPreviewProps {
  type: AnimationType;
  progress: number; // 0 ~ 1
  /**
   * 실제 아이템에 붙은 애니. 편집된 값(customOutputRanges 등)이 프리뷰에 반영된다.
   * 미지정이면 메타 기본값으로 미리본다(좌측 프리셋 패널 용도).
   */
  animation?: ItemAnimation;
}

// 프리뷰 설정
const PREVIEW_FPS = 30;
const PREVIEW_DURATION_FRAMES = 30; // 1초
const PREVIEW_DURATION_SECONDS = PREVIEW_DURATION_FRAMES / PREVIEW_FPS;

export default function AnimationPreview({
  type,
  progress,
  animation,
}: AnimationPreviewProps) {
  // progress(0~1)를 frame으로 변환하여 공용 계산 로직 사용
  const style = useMemo(() => {
    return calculateAnimationsStyle({
      animations: [
        toPreviewAnimation(type, PREVIEW_DURATION_SECONDS, animation),
      ],
      currentFrame: progress * PREVIEW_DURATION_FRAMES,
      framesPerSecond: PREVIEW_FPS,
      totalDurationInFrames: PREVIEW_DURATION_FRAMES,
    });
  }, [type, progress, animation]);

  return (
    <div className="flex h-full w-full items-center justify-center overflow-hidden rounded-xs bg-sys-style-neutral-light">
      {/* 정사각형 라운드 사각형으로 애니메이션 표시 */}
      <div
        className="aspect-square w-[25%] rounded-2xs bg-sys-style-primary-default"
        style={style}
      />
    </div>
  );
}
